import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateServicePrincipalRequirementsApi = createApi({
  reducerPath: 'policyTemplateServicePrincipalRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getServicePrincipalRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/service-principal-requirements/preview`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetServicePrincipalRequirementsPreviewQuery } = policyTemplateServicePrincipalRequirementsApi

export const useServicePrincipalRequirementsPreview = (
  { templateId, customerId: customerIdOverride },
  options = {},
) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  const customerId = customerIdOverride ?? selectedCustomerId

  return useGetServicePrincipalRequirementsPreviewQuery(
    { templateId, customerId },
    { ...options, skip: options.skip || !templateId || !customerId },
  )
}
